import React from 'react';

export default function SavedNumbers({ items, onSelect, onRemove }) {
  if (!items?.length) return null;

  return (
    <section className="saved-numbers" aria-label="เลขที่บันทึกไว้">
      <p className="saved-numbers__label">เลขของฉัน ⭐</p>
      <div className="saved-numbers__list">
        {items.map((item) => (
          <div key={item.number} className="saved-numbers__item">
            <button
              type="button"
              className="saved-numbers__chip"
              onClick={() => onSelect(item.number)}
            >
              {item.number}
            </button>
            <button
              type="button"
              className="saved-numbers__remove"
              aria-label={`ลบเลข ${item.number}`}
              onClick={() => onRemove(item.number)}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
